<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.49552 21.8682C4.67774 22.3357 3.72659 21.5158 4.06797 20.6376L11.065 2.63755C11.3955 1.78748 12.5978 1.78748 12.9283 2.63755L19.9253 20.6376C20.2667 21.5158 19.3155 22.3357 18.4978 21.8682L11.9966 18.1518L5.49552 21.8682ZM11.9966 5.75903L6.95415 18.7309L11.5007 16.1318C11.808 15.9561 12.1853 15.9561 12.4926 16.1318L17.0391 18.7309L11.9966 5.75903Z"
    fill="currentColor"
  />
</svg>
